import { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import authService from "../services/authService";
import "../components/loading.css"; 

const StudentRegistration = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    grade: "",
    age: "",
    location: "",
    class_schedule: "",
    preferred_days: [],
    payment_agreement: "",
    referral_source: "",
    prior_experience: "",
    profile_picture: null,
    agree_duration: false,
    agree_reschedule: false,
    agree_payment: false,
    agree_assignments: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : type === "file" ? files[0] : value,
    }));
  };

  // Handle preferred days separately (checkboxes)
  const handlePreferredDaysChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    setFormData((prev) => {
      if (type === "checkbox" && name === "preferred_days") {
        return {
          ...prev,
          preferred_days: checked
            ? [...(Array.isArray(prev.preferred_days) ? prev.preferred_days : []), value]
            : (Array.isArray(prev.preferred_days) ? prev.preferred_days.filter((day) => day !== value) : []),
        };
      }
  
      return {
        ...prev,
        [name]: type === "checkbox" ? checked : type === "file" ? files[0] : value,
      };
    });
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);
  
  //   const user = authService.getCurrentUser();
  //   if (!user) {
  //     Swal.fire("Error!", "User not authenticated!", "error");
  //     setLoading(false);
  //     return;
  //   }
  
  //   const submissionData = new FormData();
  //   Object.keys(formData).forEach((key) => {
  //     if (key === "preferred_days") {
  //       submissionData.append(key, JSON.stringify(Array.isArray(formData[key]) ? formData[key] : [])); // Convert array to JSON
  //     } else {
  //       submissionData.append(key, formData[key]);
  //     }
  //   });

    
  
  //   Swal.fire({
  //     title: "Processing...",
  //     html: `<div class="custom-loading">
  //               <div class="spinner">
  //                   <img src="/small_logo1.png" alt="Loading" />
  //               </div>
  //               <p>Please hold on while your request is being processed.</p>
  //            </div>`,
  //     showConfirmButton: false,
  //     allowOutsideClick: false,
  //     allowEscapeKey: false,
  //     didOpen: () => Swal.showLoading(),
  //   });
  
  //   try {
  //     const response = await axios.post(
  //       "https://doshfebackend.teemah.com.ng/api/auth/register/",
  //       submissionData,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${user.access}`,
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     );
  //     console.log("API Response Data:", response.data); // Debug API response
  //     console.log("Raw API Response:", response); // Log the full response object
  
  //     setLoading(false);
  //     setFormData({
  //       first_name: "",
  //       last_name: "",
  //       email: "",
  //       grade: "",
  //       age: "",
  //       location: "",
  //       class_schedule: "",
  //       preferred_days: [],
  //       payment_agreement: "",
  //       referral_source: "",
  //       prior_experience: "",
  //       profile_picture: null,
  //       agree_duration: false,
  //       agree_reschedule: false,
  //       agree_payment: false,
  //       agree_assignments: false,
  //       completed:false,
  //       gender: "",
  //       lecture_duration: "",
  //     });
  
  //     if (response.data.completed) {
  //       Swal.fire({
  //         title: "Success!",
  //         text: "Student registered successfully.",
  //         icon: "success",
  //         confirmButtonColor: "#007bff", // Bright blue button
  //         confirmButtonText: "<span style='font-size: 16px; font-weight: bold;'>OK</span>",
  //       }).then(() => {
  //         window.location.href = "/dashboard"; // Redirect to Dashboard
  //       });
  //     } else {
  //       Swal.fire({
  //         title: "Success!",
  //         text: "Student registered, but not marked as completed.",
  //         icon: "info",
  //         confirmButtonColor: "#007bff",
  //         confirmButtonText: "<span style='font-size: 16px; font-weight: bold;'>OK</span>",
  //       });
  //     }
  //   } catch (err) {
  //     console.error("Error registering student", err);
  //     setLoading(false);
  
  //     Swal.fire("Error!", "Failed to register student. Please try again.", "error");
  //   }
  // };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    const user = authService.getCurrentUser();
    if (!user) {
      Swal.fire("Error!", "User not authenticated!", "error");
      setLoading(false);
      return;
    }
  
    // List of required fields
    const requiredFields = [
      "first_name",
      "last_name",
      "email",
      "grade",
      "age",
      "gender",
      "location",
      "class_schedule",
      "lecture_duration",
      "payment_agreement",
      "prior_experience",
      "profile_picture",
      "referral_source",
    ];
  
    // Check for empty fields
    for (let field of requiredFields) {
      if (!formData[field]) {
        Swal.fire({
          title: "Error!",
          text: `Please fill out the ${field.replace("_", " ")} field.`,
          icon: "error",
          confirmButtonColor: "#007bff", // Customize button color
          confirmButtonText: "OK", // Ensure button appears
        });
        setLoading(false);
        return;
      }
    }
  
    // Ensure at least one preferred day is selected
    if (formData.preferred_days.length === 0) {
      
      Swal.fire({
        title: "Error!",
        text: `Please select at least one preferred days.`,
        icon: "error",
        confirmButtonColor: "#007bff", // Customize button color
        confirmButtonText: "OK", // Ensure button appears
      });
      setLoading(false);
      return;
    }
  
    // Ensure all agreement checkboxes are checked
    if (!formData.agree_duration || !formData.agree_reschedule || !formData.agree_payment || !formData.agree_assignments) {
      
      Swal.fire({
        title: "Error!",
        text: `You must agree to all terms before submitting.`,
        icon: "error",
        confirmButtonColor: "#007bff", // Customize button color
        confirmButtonText: "OK", // Ensure button appears
      });
      setLoading(false);
      return;
    }
  
    const submissionData = new FormData();
    Object.keys(formData).forEach((key) => {
      if (key === "preferred_days") {
        submissionData.append(key, JSON.stringify(formData[key]));
      } else {
        submissionData.append(key, formData[key]);
      }
    });
  
    Swal.fire({
      title: "Processing...",
      html: `<div class="custom-loading">
                <div class="spinner">
                    <img src="/dca.png" alt="Loading" />
                </div>
                <p>Please hold on while your request is being processed.</p>
             </div>`,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => Swal.showLoading(),
    });
  
    try {
      const response = await axios.post(
        "https://doshfebackend.teemah.com.ng/api/auth/register/",
        submissionData,
        {
          headers: {
            Authorization: `Bearer ${user.access}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
  
      setLoading(false);
      setFormData({
        first_name: "",
        last_name: "",
        email: "",
        grade: "",
        age: "",
        location: "",
        class_schedule: "",
        preferred_days: [],
        payment_agreement: "",
        referral_source: "",
        prior_experience: "",
        profile_picture: null,
        agree_duration: false,
        agree_reschedule: false,
        agree_payment: false,
        agree_assignments: false,
        completed: false,
        gender: "",
        lecture_duration: "",
      });
  
      Swal.fire({
        title: "Success!",
        text: response.data.completed
          ? "Student registered successfully."
          : "Student registered, but not marked as completed.",
        icon: response.data.completed ? "success" : "info",
        confirmButtonColor: "#007bff",
        confirmButtonText: "<span style='font-size: 16px; font-weight: bold;'>OK</span>",
      }).then(() => {
        window.location.href = "/dashboard";
      });
  
    } catch (err) {
      console.error("Error registering student", err);
      setLoading(false);
      Swal.fire("Error!", "Failed to register student. Please try again.", "error");
    }
  };
  

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 p-4 mt-20">
    <div className="w-full max-w-4xl bg-white shadow-lg rounded-lg p-6 mt-10">
      <h2 className="text-2xl font-semibold text-center mb-6 bg-blue-600 rounded-lg p-2 text-white">
        Student Registration
      </h2>
  
      <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* First Name */}
       
        <div>
          <label className="block font-medium">First Name</label>
          <input type="text" name="first_name" value={formData.first_name} onChange={handleChange} className="w-full p-2 border rounded" required />
        </div>
  
        {/* Last Name */}
        <div>
          <label className="block font-medium">Last Name</label>
          <input type="text" name="last_name" value={formData.last_name} onChange={handleChange} className="w-full p-2 border rounded" required />
        </div>
  
        {/* Email */}
        <div>
          <label className="block font-medium">Email</label>
          <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full p-2 border rounded" required />
        </div>
  
        {/* Grade */}
        <div>
          <label className="block font-medium">Grade</label>
          <select name="grade" value={formData.grade} onChange={handleChange} className="w-full p-2 border rounded" required>
            <option value="">Select Grade</option>
            <option value="Elementary">Elementary</option>
            <option value="Secondary">Secondary</option>
            <option value="High">High School</option>
            <option value="Tertiary">Tertiary</option>
          </select>
        </div>
  
        {/* Age */}
        <div>
          <label className="block font-medium">Age</label>
          <input type="number" name="age" value={formData.age} onChange={handleChange} className="w-full p-2 border rounded" required />
        </div>
  
        {/* Gender */}
        <div>
          <label className="block font-medium">Gender</label>
          <select name="gender" value={formData.gender} onChange={handleChange} className="w-full p-2 border rounded" required>
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Others">Others</option>
          </select>
        </div>
  
        {/* Location & Profile Picture properly aligned on left & right */}
<div>
    <label className="block font-medium">Location</label>
    <input 
      type="text" 
      name="location" 
      value={formData.location} 
      onChange={handleChange} 
      className="w-full p-2 border rounded" 
      required 
    />
  </div>

  {/* Profile Picture (Right Side) */}
  <div className="">
    <label className="block font-medium">Profile Picture</label>
    <input 
      type="file" 
      accept="image/*" 
      name="profile_picture" 
      onChange={handleChange} 
      className="w-full p-2 border rounded" 
    />
  </div>



  
        {/* Class Schedule & Preferred Days */}
        <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block font-medium">Class Schedule</label>
            <select name="class_schedule" value={formData.class_schedule} onChange={handleChange} className="w-full p-2 border rounded">
              <option value="">Select Schedule</option>
              <option value="1">1 time a week</option>
              <option value="2">2 times a week</option>
              <option value="3">3 times a week</option>
            </select>
          </div>
  
          {/* Preferred Days */}
    <div>
      <label className="block font-medium">Preferred Days</label>
      <div className="grid grid-cols-2 gap-2">
        {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"].map((day) => (
          <label key={day} className="flex items-center gap-2">
            <input type="checkbox" name="preferred_days" value={day} checked={formData.preferred_days.includes(day)} onChange={handlePreferredDaysChange} />
            {day}
          </label>
        ))}
      </div>
    </div>
          </div>
        
  
        {/* Lecture Duration */}
        <div>
          <label className="block font-medium">Lecture Duration</label>
          <select name="lecture_duration" value={formData.lecture_duration} onChange={handleChange} className="w-full p-2 border rounded" required>
            <option value="">Select Duration</option>
            <option value="One">One Hour</option>
            
          </select>
          <p className="text-red-500">The time duration will only be exceeded when necessary.</p>
        </div>
  
        {/* Prior Experience */}
        <div>
          <label className="block font-medium">Prior Experience</label>
          <select name="prior_experience" value={formData.prior_experience} onChange={handleChange} className="w-full p-2 border rounded">
            <option value="">Select Level</option>
            <option value="Beginner">Beginner</option>
            <option value="Intermediate">Intermediate</option>
            <option value="Advanced">Advanced</option>
          </select>
        </div>
  
        {/* Referral Source */}
        <div>
          <label className="block font-medium">How did you hear about us?</label>
          <input type="text" name="referral_source" value={formData.referral_source} onChange={handleChange} className="w-full p-2 border rounded" />
        </div>
  
        {/* Monthly Payment */}
        <div>
          <label className="block font-medium">Monthly Payment</label>
          <input type="text" name="payment_agreement" value={formData.payment_agreement} onChange={handleChange} className="w-full p-2 border rounded" />
        </div>
  
        {/* Agreements */}
        <div className="md:col-span-2">
  <h3 className="font-medium mb-2">Agreements</h3>
  <div className="grid grid-cols-2 gap-4">
    {/* Agree to Duration */}
    <div>
      <label className="block text-sm">
        <input
          type="checkbox"
          name="agree_duration"
          checked={formData.agree_duration}
          onChange={handleChange}
          className="mr-2"
        />
        I agree that the chosen <strong>Lecture Duration</strong> above is the one agreed upon by the client and <strong>Dosh Academy</strong>.
      </label>
    </div>

    {/* Agree to Rescheduling Policy */}
    <div>
      <label className="block text-sm">
        <input
          type="checkbox"
          name="agree_reschedule"
          checked={formData.agree_reschedule}
          onChange={handleChange}
          className="mr-2"
        />
        I acknowledge and agree that <strong>lecatures time or date</strong> can be reschedule in case of emergency by both the client and Dosh Coding Acdemy.
      </label>
    </div>

    {/* Agree to Payment Terms */}
    <div>
      <label className="block text-sm">
        <input
          type="checkbox"
          name="agree_payment"
          checked={formData.agree_payment}
          onChange={handleChange}
          className="mr-2"
        />
        I confirm that I understand and agree to the <strong>payment above</strong> .
      </label>
    </div>

    {/* Agree to Completing Assignments */}
    <div>
      <label className="block text-sm">
        <input
          type="checkbox"
          name="agree_assignments"
          checked={formData.agree_assignments}
          onChange={handleChange}
          className="mr-2"
        />
        I agree to complete all assigned coursework and <strong>assignments</strong> as per Dosh Coding Academy's guidelines.
      </label>
    </div>
  </div>
</div>

  
        {/* Submit Button */}
        <div className="md:col-span-2">
          <button type="submit" className="w-full p-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition">
            {loading ? "Submitting..." : "Register"}
          </button>
        </div>
      </form>
    </div>
  </div>
  

  );
};

export default StudentRegistration;
